export const ACTIVE_SUBSCRIPTION_STATUSES = ['active', 'lifetime', 'trial', 'trialing'];

export function hasActiveSubscription(status) {
  return ACTIVE_SUBSCRIPTION_STATUSES.includes(status);
}

export async function fetchOnboardingStatus(api) {
  try {
    const { data } = await api.get('/api/dashboard/onboarding');
    return {
      mt5_connected: Boolean(data?.mt5_connected),
      config_set: Boolean(data?.config_set),
      onboarded: Boolean(data?.onboarded),
    };
  } catch {
    return {
      mt5_connected: false,
      config_set: false,
      onboarded: false,
    };
  }
}

export async function resolvePostLoginRoute(api, subscriptionStatus, requestedPath) {
  if (!hasActiveSubscription(subscriptionStatus)) {
    return '/subscription';
  }

  const onboarding = await fetchOnboardingStatus(api);

  if (!onboarding.mt5_connected) {
    return '/account?setup=mt5';
  }

  if (!onboarding.config_set) {
    return '/account?setup=config';
  }

  if (requestedPath && !['/login', '/register', '/subscription', '/mt5-login'].includes(requestedPath)) {
    return requestedPath;
  }

  return '/account';
}